window.addEventListener("load", function () {
  var campaign_pricebook = fetch(window.Shopify.routes.root + "cart.js?for=read_cart")
    .then((response) => response.json())
    .then((data) => {
      return data.attributes.pricebook;
    });
  var freeGiftLoading = false;
  const originalXMLHttpRequestOpen = window.XMLHttpRequest.prototype.open;
  const originalFetch = window.fetch;


  function retryRequest(args, retryCount = 1) {
    const xhr = new XMLHttpRequest();
    xhr.open(...args);
    xhr.setRequestHeader("X-Retry-Attempt", retryCount);
    xhr.send();

    xhr.addEventListener("load", function () {
      if (xhr.status === 429) {
        setTimeout(() => {
          retryRequest(args, retryCount + 1);
        }, 1000 * retryCount); // exponential backoff
      }
    });
  }




  // Add to cart via http request trigger this function
  function openReplacement() {
    const url = arguments[0].split("?")[0];
    const options = arguments[1] || {};
    const isAddToCart = ["/cart/add.js", "/cart/add"].includes(url);
    const isUpdateCart = ["/cart/update.js", "/cart/update"].includes(url);
    const isChangeCart = ["/cart/change.js", "/cart/change"].includes(url);
    const isCart = ["/cart.js", "/cart"].includes(url);
    const isFreegiftToCart = ["cart/add.js?for=freegift", "cart/add?for=freegift"].includes(url);
    const isCartPf = ["/cart.js?for=qty_check_pf"].includes(url);
    const isCartDiscountHandle = ["/cart.js?for=discount_handle"].includes(url);

    const urlObj = new URL(arguments[0], window.location.origin);
    const params = Object.fromEntries(urlObj.searchParams.entries());
    const requestFor = params.for || null;

    const status = this.status;
    if (status === 429) {
      retryRequest(arguments);
      return;
    }
    
    this.addEventListener("load", function (response) {
      if (isAddToCart) {
        $(".qty-error").remove();
        $(".addto-cart-button").prop("disabled", false);
        $(".addto-cart-button").removeClass("disabled");
        $(".shop-qty-error").remove();

        // Log POST data from FormData or JSON
        const clonedResponse = response.clone();
        
        clonedResponse.text().then((data) => {

          var item = JSON.parse(data);
          if (item.status == 422 && item.message.includes("maximum")) {
            handleQuantityError(options,item.message.includes("quantity"));
          } else {

              try {

                          var item = JSON.parse(data);
                          var url_item = item.url;
                          var properties = item.properties;
                          var quantity = item.quantity;
                          var selling_plan_id = item.selling_plan_allocation?.selling_plan.id;
                          var selling_plan_name = item.selling_plan_allocation?.selling_plan.name;
                          var item_key = item.key;
                          
                         // add_free_gift(properties._line_item_id,url_item,selling_plan_id,item.id)
                          qty_limit();
                          addPriceBook(
                            item.id,
                            item_key,
                            url_item,
                            properties,
                            quantity,
                            selling_plan_id,
                            selling_plan_name
                          );
                          
                                          
              } catch (error) {
                console.log(error)
              }    
          }
        });
      } else if (isUpdateCart) {
        qty_limit();
        try {
         
          if (options.body != null) {
            var param = JSON.parse(options.body);
            if (param.quantity == 0) {
              $(".qty-error").remove();
              $('[class^="qty-error"]').remove();
              $("[name='add']").removeClass("button_or_link_disabled");
              $(".addto-cart-button").prop("disabled", false);
              $(".addto-cart-button").removeClass("disabled");
              $(".shop-qty-error").remove();

              if(param.quantity==0 && requestFor != "remove_sas_qty"){
                  removeInvalidQualifyingLineItems();
              }

            }
          }
        } catch (error) {
          console.log(error);
        }
        response.text().then((data) => {
          var item = JSON.parse(data);
          var status = item.status;
          if (status == 422) {
            try {
              try {
                handleQuantityError(options);
              } catch (error) {
                console.log(error);
              }
            } catch (error) {
              console.log(error);
            }
          }
        });
      } else if (isChangeCart) {

         var param = JSON.parse(options.body);

         if(param.quantity==0){
            removeInvalidQualifyingLineItems();
         }
         if(param.quantity>=1){
            replaceQualifyingLineItemsQty(param.line);
         }
        $('[class^="qty-error"]').remove();
        $("[name='add']").removeClass("button_or_link_disabled");
        return response;
      }
      return response;
    });
    return originalXMLHttpRequestOpen.apply(this, arguments);
  }
  window.XMLHttpRequest.prototype.open = openReplacement;


  function fetchWithRetry(origUrl, options, retryCount = 0) {
    return originalFetch(origUrl, options).then((response) => {
      if (response.status === 429 && retryCount === 0) {
        console.warn("429 Too Many Requests – retrying after delay...");
        return new Promise((resolve) => {
          setTimeout(() => {
            fetchWithRetry(origUrl, options, 1).then(resolve);
          }, 1500);
        });
      }
      return response;
    });
  }

  // Add to cart via fetch request trigger this function
  function fetchReplacement() {
    const origUrl = arguments[0];
    const url = arguments[0].split("?")[0];
    const queryString = origUrl.split('?')[1] || '';
    const urlParams = new URLSearchParams(queryString);
    const forParam = urlParams.get('for');
    const options = arguments[1] || {};
    const isAddToCart = ["/cart/add.js", "/cart/add"].includes(url);
    const isUpdateCart = ["/cart/update.js", "/cart/update"].includes(url);
    const isChangeCart = ["/cart/change.js", "/cart/change"].includes(url);
    const isCart = ["/cart.js", "/cart"].includes(url);
    return fetchWithRetry(origUrl, options).then((response) => {

      if (isAddToCart && forParam != "freegift" && forParam != "sasorpreupsell") {
       const clonedResponse = response.clone();     
      if(!response.ok) {

        if (response.status == 422 ) {
          try {
            try {
              clonedResponse.text().then((data) => {
                var item = JSON.parse(data);
                if (item.status == 422 && item.message.includes("maximum")) {
                  handleQuantityError(options,item.message.includes("quantity"));
                } 
              });
            } catch (error) {
              handleQuantityError(options);
            }
          } catch (error) {
            console.log(error);
          }
        }
        return response;
      }
  
        $(".qty-error").remove();
        $(".addto-cart-button").prop("disabled", false);
        $(".addto-cart-button").removeClass("disabled");
        $(".shop-qty-error").remove();
     
      clonedResponse.text().then((item) => {
          if (item.status == 422 && item.message.includes("maximum")) {
            try {
              handleQuantityError(options,item.message.includes("quantity"));
            } catch (error) {
              console.log(error);
            }
          } else {
          
                var item_data = JSON.parse(item);
                var url_item = item_data.url;
                var properties = item_data.properties;
                var quantity = item_data.quantity;
                var selling_plan_id = item_data.selling_plan_allocation?.selling_plan.id;
                var selling_plan_name = item_data.selling_plan_allocation?.selling_plan.name;
                var item_key = item_data.key;
               
                       // add_free_gift(properties._line_item_id,url_item,selling_plan_id,item_data.id)
                        qty_limit();
                        addPriceBook(
                          item_data.id,
                          item_key,
                          url_item,
                          properties,
                          quantity,
                          selling_plan_id,
                          selling_plan_name
                        );
        
         
          }
        });
      } else if (isUpdateCart) {
        qty_limit();
        try {
          if (options.body != null) {
            var param = JSON.parse(options.body);
            if (param.quantity == 0) {          
              $(".qty-error").remove();
              $('[class^="qty-error"]').remove();
              $("[name='add']").removeClass("button_or_link_disabled");
              $(".addto-cart-button").prop("disabled", false);
              $(".addto-cart-button").removeClass("disabled");
              $(".shop-qty-error").remove();
  
   
              if(param.quantity==0 && forParam != "remove_sas_qty"){
                removeInvalidQualifyingLineItems();
              }

            }
          }
        } catch (error) {
          console.log(error);
        } 
        response.text().then((data) => {
          var item = JSON.parse(data); 
          var status = item.status;
          if (status == 422) {
            try {
              handleQuantityError(options);
            } catch (error) {
              console.log(error);
            }
          }
        });
        return response;
      } else if (isChangeCart) {
         var param = JSON.parse(options.body);

         if(param.quantity==0){
            removeInvalidQualifyingLineItems()
         }
          if(param.quantity>=1){
           replaceQualifyingLineItemsQty(param.line);
         }
         $('[class^="qty-error"]').remove();
         $("[name='add']").removeClass("button_or_link_disabled");
        return response;

      } else if (isCart && forParam == "pdp_callback") {
        if(!freeGiftLoading){
          freeGiftLoading = true;
          $(".hs-site-cart-popup-layout").addClass("hs-is-loading");
          //checkAndAddFreeGift().then(results => {
            removedLineItemsPriceGift();
            freeGiftLoading = false;
            $(".hs-checkout-purchase").removeClass("button_or_link_disabled");
            $(".hs-site-cart-popup-layout").removeClass("hs-is-loading");
         // });
        }
      
        return response;
      }else if (isCart && (forParam == "discount_handle") ) {
        removeCheckoutFreeGift();
        removedLineItemsPriceGift();
        return response;
      }
      return response;
    });
  }
  window.fetch = fetchReplacement;

  $(".rc-radio__input").on("change", function () {
    $('[action="/cart/add"]').find(".qty-error").remove();
    $('[action="/cart/add"]')
      .find(".addto-cart-button")
      .prop("disabled", false);
    $(".addto-cart-button").removeClass("disabled");
    $(".qty-error").remove();
  });

  /**
       addPriceBook() : To update the pricebook values in the cart
       Arg : items_id- Product is currently added to the cart utilizing the Product ID provided here.  
       product_key -  Product is currently added to the cart utilizing the Product Cart key provided here.  
    **/
  function addPriceBook(
    items_id,
    product_key,
    product_url,
    properties,
    quantity,
    selling_plan_id,
    selling_plan_name,
    product_handle
  ) {
    fetch(window.Shopify.routes.root + "cart.js?for=price_book")
      .then((response) => response.json())
      .then((data) => {
        var campaign_pb = data;
        if (product_url) {
          var selling_plan_id_param = (selling_plan_id != null && selling_plan_id != "")? "&selling_plan=" + selling_plan_id:"";
          var variant_id_param = (items_id!=null && items_id != "")? "&variant=" + items_id:"";

          jQuery.get(
            product_url + "&for=price_book&view=get_product_info_template"+selling_plan_id_param+variant_id_param,
            async function (datap) {
              
              var pb_info = JSON.parse(datap);
              // add_free_gift(pb_info.free_gifts,product_key);
              if (selling_plan_id != null && selling_plan_id != "") {
                if (pb_info.price_book != null && pb_info.price_book != "") {
                  var pricebook = { _pricebook: pb_info.price_book };
                } else {
                  var pricebook = {
                    _pricebook: campaign_pb.attributes.pricebook,
                  };
                }
              } else {
                var pricebook = {};
              }
              if (properties != null) {
                var exist_properties = properties;
                if (properties._product_from_PDP == null) {
                  if (selling_plan_id != null && selling_plan_id != "") {
                    //avoid empty properties _subscription_terms:""
                    if (pb_info.subscription_terms != "") {
                      var subscription_terms = {
                        _subscription_terms: pb_info.subscription_terms,
                      };
                    }
                  } else {
                    var subscription_terms = {};
                  }
                  switch (pb_info.pus_type) {
                    case "subscription":
                      if (selling_plan_id != null && selling_plan_id != "") {
                        var exist_properties = Object.assign(
                          {
                            _product_from_PDP: "NOT_PDP",
                            _preupsell_link: pb_info.pus_url,
                            _preupsell_product_selling_plan: selling_plan_name,
                            _preupsell_variants: pb_info.pus_variants,
                            _preupsell_add_or_upgrade_cart:
                              pb_info.pus_add_or_upgrade_cart,
                          },
                          subscription_terms
                        );
                      }
                      break;
                    case "onetime":
                      if (selling_plan_id == null && selling_plan_id == "") {
                        var exist_properties = Object.assign(
                          {
                            _product_from_PDP: "NOT_PDP",
                            _preupsell_link: pb_info.pus_url,
                            _preupsell_product_selling_plan: selling_plan_name,
                            _preupsell_variants: pb_info.pus_variants,
                            _preupsell_add_or_upgrade_cart:
                              pb_info.pus_add_or_upgrade_cart,
                          },
                          subscription_terms
                        );
                      }
                      break;
                    default:
                      var exist_properties = Object.assign(
                        {
                          _product_from_PDP: "NOT_PDP",
                          _preupsell_link: pb_info.pus_url,
                          _preupsell_product_selling_plan: selling_plan_name,
                          _preupsell_variants: pb_info.pus_variants,
                          _preupsell_add_or_upgrade_cart:
                            pb_info.pus_add_or_upgrade_cart,
                        },
                        subscription_terms
                      );
                      break;
                  }
                } 
              } else {
                if (selling_plan_id != null && selling_plan_id != "") {
                  //avoid empty properties _subscription_terms:""
                  if (pb_info.subscription_terms != "") {
                    var subscription_terms = {
                      _subscription_terms: pb_info.subscription_terms,
                    };
                  }
                } else {
                  var subscription_terms = {};
                }
                switch (pb_info.pus_type) {
                  case "subscription":
                    if (selling_plan_id != null && selling_plan_id != "") {
                      var exist_properties = Object.assign(
                        {
                          _product_from_PDP: "NOT_PDP",
                          _preupsell_link: pb_info.pus_url,
                          _preupsell_product_selling_plan: selling_plan_name,
                          _preupsell_variants: pb_info.pus_variants,
                          _preupsell_add_or_upgrade_cart:
                            pb_info.pus_add_or_upgrade_cart,
                        },
                        subscription_terms
                      );
                    }
                    break;
                  case "onetime":
                    if (selling_plan_id == null && selling_plan_id == "") {
                      var exist_properties = Object.assign(
                        {
                          _product_from_PDP: "NOT_PDP",
                          _preupsell_link: pb_info.pus_url,
                          _preupsell_product_selling_plan: selling_plan_name,
                          _preupsell_variants: pb_info.pus_variants,
                          _preupsell_add_or_upgrade_cart:
                            pb_info.pus_add_or_upgrade_cart,
                        },
                        subscription_terms
                      );
                    }
                    break;
                  default:
                    var exist_properties = Object.assign(
                      {
                        _product_from_PDP: "NOT_PDP",
                        _preupsell_link: pb_info.pus_url,
                        _preupsell_product_selling_plan: selling_plan_name,
                        _preupsell_variants: pb_info.pus_variants,
                        _preupsell_add_or_upgrade_cart:
                          pb_info.pus_add_or_upgrade_cart,
                      },
                      subscription_terms
                    );
                    break;
                }
              }

              if( exist_properties._product_from_PDP !="PDP" ){
                var product_from_PDP = "0"
              }else{
                var product_from_PDP = "1";
              }

              var giftproduct = (pb_info.free_gifts.length > 0) || (pb_info.default_free_gift > 0) || (pb_info.manual_free_gift > 0);
             
              if( selling_plan_id != undefined && selling_plan_id !="" && giftproduct ){
                var line_item_id = { "_line_item_id": items_id+":"+selling_plan_id+"-"+product_from_PDP};
              }else if( selling_plan_id == "" && giftproduct ){
                var line_item_id = { "_line_item_id": items_id+":"+product_from_PDP};
              }else{
                var line_item_id = {};
              }

              var allProperties = Object.assign({}, exist_properties, pricebook,line_item_id);
              let formData = {
                properties: allProperties,
                id: product_key.toString(),
                quantity: quantity,
              };
              //var addfreegift = add_free_gift(allProperties._line_item_id,product_url,selling_plan_id,items_id,pb_info);
              fetch(window.Shopify.routes.root + "cart/change.js?type=pricebook", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
              })
                .then((data) => {
                 
                    slide_cart_click(campaign_pb);
                    $(".hs-checkout-purchase").removeClass(
                      "button_or_link_disabled"
                    );
                 
                })
                .catch((error) => {
                  console.error("Fetch error:", error);
                });
            }
          );
        }
      });
  }


  function slide_cart_click(cart) {
    if ($(".pdp-page").length > 0) {
      $(".header__icon--cart")[0].click();
    }
    if ($(".collection-hero").length > 0) {
      $(".header__icon--cart")[0].click();
    }
    if ($(".template-search").length > 0) {
      $(".header__icon--cart")[0].click();
    }
    if ($(".default-shop").length > 0) {
      $(".header__icon--cart")[0].click();
    }
    let pdp_callbacks = new PdpCallbacks(cart);
  }

  function check_quantity(gift_product, cart_items) {
    if (gift_product == null) {
      return false;
    }
    var quantity = 0;
    var filteredGiftItems = cart_items.filter(
      (item) => item.id === gift_product
    );
    var quantity = filteredGiftItems.length;
    return quantity < 1;
  }


  function handleQuantityError(options,show_error=false) {

    if (options.body) {
      const { ["product_id"]: product_id } = parseRequestBody(options);
      const { ["product_variant_id"]: product_variant_id } =
        parseRequestBody(options);
      const { ["post_product_qty"]: post_product_qty } =
        parseRequestBody(options);
 
      $('[value="' + product_variant_id + '"]')
        .closest('[action="/cart/add"]')
        .find(".qty-error")
        .remove();
      $(".pdp-" + product_id)
        .find(".addto-cart-button")
        .removeClass("disabled");
      $('[value="' + product_variant_id + '"]')
        .closest('[action="/cart/add"]')
        .find(".shop-qty-error")
        .remove();
      if (product_variant_id != "") {
        const count = $('[action="/cart/add"]').find(
          `[value="${product_variant_id}"]`
        ).length;
        if (count > 0) {
          const errorMessage =
            "Your shopping cart already contains the maximum allowed quantity of this product.";
          const showErrorMessage =  "-1"; //For Maximum 1 Quantity
          if (
            $(".pdp-page").length > 0 &&
            $('[value="' + product_variant_id + '"]')
              .closest('[action="/cart/add"]')
              .find(".addto-cart-button").length > 0
          ) {
            $('[class^="qty-error"]').remove();
            $("[name='add']").removeClass("button_or_link_disabled");
            $('[value="' + product_variant_id + '"]')
                .closest('[action="/cart/add"]')
                .find("[name='add']").addClass("button_or_link_disabled");
                
          //if(show_error){
            $(
              '<div class="qty-error'+showErrorMessage+'">' + errorMessage + "<br></div>"
            ).insertAfter(
              $('[value="' + product_variant_id + '"]')
                .closest('[action="/cart/add"]')
                .find("[name='add']")
            );
            $(
              '<div class="qty-error'+showErrorMessage+'">' + errorMessage + "<br></div>"
            ).insertAfter(
              $(".pdp-sticky-footer-ctr").find("#stickyFooterAddToCart")
            );
        
            $(".pdp-sticky-footer-ctr")
              .find(".addto-cart-button")
              .addClass("disabled");
            $(".addto-cart-button").prop("disabled", true);
          } else {
            $(
              '<span class="shop-qty-error">' + errorMessage + "</span>"
            ).insertAfter(
              $("#subscribe-" + product_id + " .ingpopup")
                .children()
                .first()
            );
          }
        }
      }
    }
  }

  function parseRequestBody(options) {
    let product_variant_id = "";
    let product_id = "";
    let post_product_qty = 0;
    if (options.body instanceof FormData) {
      for (let [key, value] of options.body.entries()) {
        switch (key) {
          case "id":
            product_variant_id = value;
            break;
          case "product-id":
            product_id = value;
            break;
          case "quantity":
            post_product_qty = value;
            break;
        }
      }
    } else if (typeof options.body === "string") {
      try {
        JSON.parse(options.body);
      } catch (error) {
        console.error("Error parsing JSON body:", error);
      }
    }
    return { product_variant_id, product_id, post_product_qty };
  }

  function qty_limit() {
    fetch(window.Shopify.routes.root + "cart.js?for=qty_check_pf")
      .then((response) => response.json())
      .then((data) => {
        if ($(".qty-error").length <= 0) {
           
          $(".qty-error").remove();
        }
        const items = data.items;
        const product_id = $('[name="id"]').attr("data-productid");
        const product_variant_id = $('[name="id"]').val();
        var item_count = [];
        if (
          $(".pdp-" + product_id)
            .find('[name="purchaseOption"]:checked')
            .val() == "onetime"
        ) {
          item_count = items.filter(
            (itm) =>
              itm.id == product_variant_id &&
              typeof itm.selling_plan_allocation?.selling_plan.id !== "number"
          );
        }
        if (
          $(".pdp-" + product_id)
            .find('[name="purchaseOption"]:checked')
            .val() == "subscription"
        ) {
          item_count = items.filter(
            (itm) =>
              itm.id == product_variant_id &&
              typeof itm.selling_plan_allocation?.selling_plan.id === "number"
          );
        }
        if (item_count.length == 0) {
          if (
            $(".pdp-" + product_id)
              .find('[name="purchaseOption"]:checked')
              .val() == "onetime"
          ) {
            $(".pdp-" + product_id)
              .find(".quantity__input")
              .attr("max", "2");
            $(".addto-cart-button").prop("disabled", false);
            $(".addto-cart-button").removeClass("disabled");
            if ($(".qty-error").length > 0) {
              $(".pdp-" + product_id)
                .find(".qty-error")
                .remove();
          
              $(".qty-error").remove();
            }
          }
          if (
            $(".pdp-" + product_id)
              .find('[name="purchaseOption"]:checked')
              .val() == "subscription"
          ) {
            $(".pdp-" + product_id)
              .find(".quantity__input")
              .attr("max", "2");
            $(".addto-cart-button").prop("disabled", false);
            $(".addto-cart-button").removeClass("disabled");
            if ($(".qty-error").length > 0) {
      
              $(".qty-error").remove();
              $(".addto-cart-button").prop("disabled", false);
              $(".addto-cart-button").removeClass("disabled");
            }
          }
        } else {
          // Determine the selected purchase option
          var purchaseOption = $(".pdp-" + product_id)
            .find('[name="purchaseOption"]:checked')
            .val();
          // Filter items based on the selected purchase option
          if (
            $(".pdp-" + product_id)
              .find('[name="purchaseOption"]:checked')
              .val() == "onetime"
          ) {
            // Filter items with selling plan allocation using map function
            var filteredItems = data.items.filter(function (item) {
              return (
                typeof item.selling_plan_allocation?.selling_plan.id !==
                  "number" && item.id == product_variant_id
              );
            });
            filteredItems.forEach((item) => {
              try {
                if (
                  $(".pdp-" + product_id).length > 0 &&
                  $('[name="id"').val() == product_variant_id
                ) {
                  var quantity = parseInt(item.quantity);
                  if (
                    $(".pdp-" + product_id)
                      .find('[name="purchaseOption"]:checked')
                      .val() == "onetime"
                  ) {
                    var cart_item_qty = 2 - parseInt(item.quantity);
                    var input_cart_item_qty =
                      cart_item_qty < 1 ? 1 : cart_item_qty;
                    $(".pdp-" + product_id)
                      .find(".quantity__input")
                      .attr("max", input_cart_item_qty);
                    $(".pdp-" + product_id)
                      .find(".quantity__input")
                      .attr("value", input_cart_item_qty);
                    cart_item_onetime_qty = cart_item_qty;
                    if (cart_item_qty > 0) {
                      $(".addto-cart-button").prop("disabled", false);
                      $(".addto-cart-button").removeClass("disabled");
                      if ($(".qty-error").length > 0) {
                      
                        $(".qty-error").remove();
                      }
                    }
                  }
                }
              } catch (error) {}
            });
          } else if (
            $(".pdp-" + product_id)
              .find('[name="purchaseOption"]:checked')
              .val() == "subscription"
          ) {
            var filteredItems = data.items.filter(function (item) {
              return (
                typeof item.selling_plan_allocation?.selling_plan.id ===
                  "number" && item.id == product_variant_id
              );
            });
            filteredItems.forEach((item) => {
              try {
                if (
                  $(".pdp-" + product_id).length > 0 &&
                  $('[name="id"').val() == product_variant_id
                ) {
                  var quantity = parseInt(item.quantity);
                  if (
                    $(".pdp-" + product_id)
                      .find('[name="purchaseOption"]:checked')
                      .val() == "subscription"
                  ) {
                    var cart_item_qty = 2 - parseInt(item.quantity);
                    cart_item_subscription_qty = cart_item_qty;
                    if (cart_item_qty > 0) {
                      $(".addto-cart-button").prop("disabled", false);
                      $(".addto-cart-button").removeClass("disabled");
                      if ($(".qty-error").length > 0) {
              
                        $(".qty-error").remove();
                      }
                    }
                  }
                }
              } catch (error) {}
            });
          }
        }
      });
  }

 
//add free gift
async function add_free_gift(qualifyUnicIDValue="",product_url="",selling_plan_id="",items_id="",pb_info={},cart_quantity=1) {
 $(".hs-checkout-purchase").addClass("button_or_link_disabled");

       try {
          // If pb_info is empty, fetch from URL
          if (Object.keys(pb_info).length === 0) {
            const params_avail = (!product_url.includes("?")) ? "?" : "&";
            const selling_plan_id_param = (!product_url.includes("selling_plan=")) ? "&selling_plan=" + selling_plan_id : "";
            const variant_id_param = (!product_url.includes("variant=")) ? "&variant=" + items_id : "";
            const url = product_url + params_avail + "view=get_product_info_template" + selling_plan_id_param + variant_id_param;

            const res = await fetch(url);
            const text = await res.text();
            pb_info = JSON.parse(text);
          }

          const giftproduct = (pb_info.free_gifts.length > 0) ? pb_info.free_gifts : pb_info.default_free_gift;

          if (!giftproduct || giftproduct.length === 0) return "";

          const freeGiftData = giftproduct.map(item => ({
            ...item,
            quantity:(cart_quantity*item.quantity),
            properties: {
              ...item.properties,
              _qualifying_line_item_id: qualifyUnicIDValue,
            }
          }));

          const formData = { items: freeGiftData };

          const freegiftresponse = await fetch("/cart/add.js?for=freegift", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });

          const freegiftresponseData = await freegiftresponse.json();
          console.log("freegiftresponseData",freegiftresponseData)

          $(".hs-checkout-purchase").removeClass("button_or_link_disabled");

          return freegiftresponseData;

        } catch (error) {
          console.error("Error:", error);
          $(".hs-checkout-purchase").removeClass("button_or_link_disabled");
          return "";
        }

}

  function removeInvalidQualifyingLineItems() {
              fetch("/cart.js?for=freegift_remove", {
                method: "get",
                headers: {
                  "Content-Type": "application/json",
                }
              })    
              .then(response => response.json())
              .then((data) => {

                  var items = data.items;
                   var cartitems = items.filter(
                              (item) =>
                                item.properties &&
                                item.properties._is_free_gift === "free-gift" &&
                                !items.some(
                                  (aval_item) =>
                                    aval_item.properties._line_item_id == item.properties._qualifying_line_item_id
                                )
                            )
                            .reduce((acc, item) => {
                              acc[item.key] = 0;
                              return acc;
                            }, {})
                  var remove_free_gift = {
                          updates: cartitems
                        };

                        if(remove_free_gift != "") {
                          fetch('/cart/update.js?for=freegift_remove', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(remove_free_gift)
                          })
                          .then(data => {
                            console.log('Free gift items removed:', data);
                            // Optionally trigger a cart refresh or UI update here
                          })
                          .catch(error => {
                            console.error('Error removing free gift items:', error);
                          });
                        }
              })
              .catch((error) => {
                console.error("Fetch error:", error);
              });

  }

// If same item without discount to remove gift 
    function removedLineItemsPriceGift() {
              fetch("/cart.js?for=discount_without_freegift_remove", {
                method: "get",
                headers: {
                  "Content-Type": "application/json",
                }
              })    
              .then(response => response.json())
              .then((data) => {
                  var items = data.items;
                   var cartitems = items.filter(
                              (item) =>
                                item.properties &&
                                 item.properties._is_free_gift === "free-gift" &&
                                item.line_price > 0 &&
                                items.some(
                                  (aval_item) =>
                                    aval_item.properties._line_item_id == item.properties._qualifying_line_item_id
                                )
                            )
                            .reduce((acc, item) => {
                              acc[item.key] = 0;
                              return acc;
                            }, {})
                  var remove_free_gift = {
                          updates: cartitems
                        };

                        if(remove_free_gift != "") {
                          fetch('/cart/update.js?for=discount_without_freegift_remove', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(remove_free_gift)
                          })
                          .then(data => {
                            console.log('Free gift items removed:', data);
                            // Optionally trigger a cart refresh or UI update here
                          })
                          .catch(error => {
                            console.error('Error removing free gift items:', error);
                          });
                        }
              })
              .catch((error) => {
                console.error("Fetch error:", error);
              });

  }

  function replaceQualifyingLineItemsQty(line=null) {
 
  var lineitem = line - 1
    fetch("/cart.js?for=freegift_qty_handle", {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      }
    })    
    .then(response => response.json())
    .then((data) => {

        var kititems = data.items[lineitem];
          if(kititems){
        var matchingQuantity = kititems.quantity;
        var matchingUnicLineitemId = kititems.properties._line_item_id;
        var items = data.items;
        var cartitems = items.filter(
                  (item) =>
                    item.properties &&
                    item.properties._is_free_gift === "free-gift" && 
                    item.properties._qualifying_line_item_id == matchingUnicLineitemId
                )
                .reduce((acc, item) => {
                  acc[item.key] = matchingQuantity;
                  return acc;
                }, {})
                var qty_free_gift = {
                  updates: cartitems
                };

              if(qty_free_gift != "") {
                fetch('/cart/update.js?for=freegift_qty', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(qty_free_gift)
                })
                .then(data => {
                  console.log('Free gift items QTY:', data);
                  removedLineItemsPriceGift();
                })
                .catch(error => {
                  console.error('Error QTY free gift items:', error);
                });
                  }
              }
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });

}

  function removeCheckoutFreeGift() {
              fetch("/cart.js?for=checkoutfreegift_remove", {
                method: "get",
                headers: {
                  "Content-Type": "application/json",
                }
              })    
              .then(response => response.json())
              .then((data) => {

                  var items = data.items;
           
                   var cartitems = items.filter(
                              (item) =>
                                item.properties &&
                                item.properties._checkout_freegift == "true"
                            )
                            .reduce((acc, item) => {
                              acc[item.key] = 0;
                              return acc;
                            }, {})
                  var remove_free_gift = {
                          updates: cartitems
                        };

                        if(remove_free_gift != "") {
                          fetch('/cart/update.js?for=checkoutfreegift_remove', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(remove_free_gift)
                          })
                          .then(data => {
                            console.log('Checkout Free gift items removed:', data);
                            // Optionally trigger a cart refresh or UI update here
                          })
                          .catch(error => {
                            console.error('Error removing Checkout free gift items:', error);
                          });
                        }
              })
              .catch((error) => {
                console.error("Fetch error:", error);
              });

  }



async function checkAndAddFreeGift() {


   const giftPromises = await fetch("/cart.js?for=checkAnd_add_freeGift", {
                method: "get",
                headers: {
                  "Content-Type": "application/json",
                }
              })    
              .then(response => response.json())
              .then((data) => {

                    const items = data.items;
                    if(items.filter(item => !items.some((itm=> itm.properties._qualifying_line_item_id === item.properties._line_item_id ))).length>0){

                        items.filter(item => !items.some((itm=> itm.properties._qualifying_line_item_id === item.properties._line_item_id ))).map(item => {

                          const propertiesLineItem = item.properties._line_item_id;
                          const variantIdLineItem = item.id;
                          const sellingPlanIdLineItem = item.selling_plan_allocation?.selling_plan.id;
                          const urlLineItem = item.url;
                          const quantityLineItem = item.quantity;
                          return "";
                          //return add_free_gift(propertiesLineItem, urlLineItem, sellingPlanIdLineItem, variantIdLineItem,{},quantityLineItem);
                        });

                    }else{
                        $(".hs-checkout-purchase").removeClass("button_or_link_disabled");
                        $(".hs-site-cart-popup-layout").removeClass("hs-is-loading");
                      return true; 
                    }
              }).catch((error) => {
                console.error("Fetch error:", error);
              });


  return true; 

}

});